import { apiGet} from '../standardApi';

export async function apiGetHealthService () {
  const response = await apiGet(`/Clients/GetMySanteClairUrlWithClientId`, 'application/json');
  return response;
}

export async function apiGetCarteBlancheLink () {
  const response = await apiGet(`/Sso/GetCarteBlancheLink`, 'application/json');
  return response;
}
